import {Inject, Injectable, NgZone} from '@angular/core';
import {AppConfigService} from '../../common/service/app-config.service';
import {SpatialUtilService} from './spatial-util.service';
import {NgEventBus} from 'ng-event-bus';
import {distinctUntilChanged, fromEvent, map, merge, Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class SelectionUtilityService {
    title = 'SelectionUtilityService';

    private multiSelect = false;
    private ctrlKeyDown = false;
    private shiftKeyDown = false;
    private keySub: Subscription;

    constructor(
        private appConfigService: AppConfigService,
        private spatialUtilService: SpatialUtilService,
        private eventBus: NgEventBus
    ) {}

    init(document: Document, ngZone: NgZone): void {
        if (this.keySub && !this.keySub.closed) return; // Prevent duplicate setup

        ngZone.runOutsideAngular(() => {
            this.keySub = merge(
                fromEvent<KeyboardEvent>(document, 'keydown').pipe(
                    filter(e => e.key === 'Control' || e.key === 'Shift'),
                    map(e => ({key: e.key, isDown: true}))
                ),
                fromEvent<KeyboardEvent>(document, 'keyup').pipe(
                    filter(e => e.key === 'Control' || e.key === 'Shift'),
                    map(e => ({key: e.key, isDown: false}))
                )
            )
                .pipe(distinctUntilChanged((a, b) => a.key === b.key && a.isDown === b.isDown))
                .subscribe(({key, isDown}) => {
                    if (key === 'Control') this.ctrlKeyDown = isDown;
                    if (key === 'Shift') this.shiftKeyDown = isDown;
                });
        });
    }

    destroy(): void {
        this.keySub?.unsubscribe();
    }

    private isMapVisible(): boolean {
        const mapElement = document.getElementById(this.appConfigService.getDesignProperties().DESIGN_SETTINGS.DEFAULT_MAP.ID);
        return mapElement?.offsetParent !== null;
    }

    clearGraphics(map: any): void {
        let reApplyEnlargementSelection = false;
        let reApplyClippingSelection = false;
        let enlargementGraphic: any = undefined;

        this.spatialUtilService.unhighlightAllFeatures();

        const mapGraphics = [...this.spatialUtilService.getMapGraphicsArray()];
        mapGraphics.forEach(graphic => {
            if (graphic.attributes?.type === 'enlargementGraphic') {
                reApplyEnlargementSelection = true;
                enlargementGraphic = graphic;
            } else if (graphic.attributes?.type === 'clippingGraphic') {
                reApplyClippingSelection = true;
                enlargementGraphic = graphic;
            } else {
                this.spatialUtilService.removeMapGraphic(graphic);
            }
        });

        if (reApplyEnlargementSelection && enlargementGraphic) {
            this.eventBus.cast('reApplySelection', enlargementGraphic);
        }
    }

    enlargementGraphic(map: any, flag: boolean): any {
        let isEnlargement = false;
        let enlargement: any;

        const mapGraphics = this.spatialUtilService.getMapGraphicsArray();
        mapGraphics.forEach(graphic => {
            if (graphic.attributes?.type === 'enlargementGraphic') {
                isEnlargement = true;
                enlargement = graphic;
            }
        });

        return flag ? enlargement : isEnlargement;
    }

    multiSelectEnabled(enable?: boolean): boolean {
        if (enable !== undefined) {
            this.multiSelect = enable;
        }
        return this.ctrlKeyDown || this.multiSelect || this.shiftKeyDown;
    }

    isCtrlKeyDown(): boolean {
        return this.ctrlKeyDown;
    }

    isShiftKeyDown(): boolean {
        return this.shiftKeyDown;
    }
}
